import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Button from "@atlaskit/button/new";
import ConfirmModal from "../common/components/ConfirmModal";
import { deleteBackupFile } from "../redux/actions/backupRestoreActions";

const DeleteBackup = ({ backupFileRef, filename }) => {
  const dispatch = useDispatch();
  const [isOpen, setOpen] = useState(false);

  const onConfirm = () => {
    dispatch(deleteBackupFile(backupFileRef, true));
    setOpen(false);
  };

  return (
    <>
      <Button onClick={() => setOpen(true)} appearance="link">
        Delete
      </Button>

      <ConfirmModal
        action={"delete backup"}
        additionalDescription={
          <p>
            <b>Note:</b>
            This will <b>delete</b> the backup file!
          </p>
        }
        targetName={filename || ""}
        targetId={backupFileRef}
        isOpen={isOpen}
        onAction={onConfirm}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

export default DeleteBackup;
